var _circle, _mask, _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconLightGrayRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 30,
    cy: 30,
    r: 29.5,
    transform: "rotate(90 30 30)",
    fill: "#F2F3F8",
    stroke: "#7583F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5538_2741",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8284 24H40.0188V40.0002C40.0188 41.1047 39.1234 42.0002 38.0188 42.0002H21.8284C20.7238 42.0002 19.8284 41.1047 19.8284 40.0002V24Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8284 24H40.0188V40.0002C40.0188 41.1047 39.1234 42.0002 38.0188 42.0002H21.8284C20.7238 42.0002 19.8284 41.1047 19.8284 40.0002V24Z",
    fill: "#9296AC",
    stroke: "#9296AC",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_5538_2741)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5H42V22.5H18V19.5Z",
    fill: "#9296AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1955 18.4783C24.3771 18.1812 24.7003 18 25.0486 18H34.7991C35.1474 18 35.4705 18.1812 35.6522 18.4783L36.9905 20.6667H22.8572L24.1955 18.4783Z",
    fill: "#9296AC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.5052,
    height: 3.37724,
    transform: "matrix(0.708752 -0.705458 0.718986 0.695024 24 36.5908)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.5004,
    height: 3.37842,
    transform: "matrix(-0.695805 -0.718231 0.731492 -0.68185 33.4617 39)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconLightGrayRounded);
export default __webpack_public_path__ + "static/media/trashIconLightGrayRounded.450de8dc80015cd0e80b4934c02084b8.svg";
export { ForwardRef as ReactComponent };